module.exports = __webpack_public_path__ + "static/media/tv-show.e749f90b.png";